import Box from "glesys-controlpanel/components/box";
import Table from "glesys-controlpanel/components/table";
import TableTd from "glesys-controlpanel/components/table/td";
import Copyable from "glesys-controlpanel/components/copyable";
import { t } from "ember-intl";

const tableData = (url) => [{ key: "URL", value: url }];

<template>
  <Box data-test-database-details-monitoring>
    <:header>{{t "label.monitoring"}}</:header>
    <:default>
      <span class="text-gray-500 text-base">
        {{t "databases.details.monitoring-info"}}
      </span>

      <Table class="mx-[-25px] mb-[-25px] mt-8" @items={{tableData @url}} @footer={{false}} @outsideBorders={{false}}>
        <:body as |item|>
          <TableTd class="w-1/6 text-gray-600">{{item.key}}</TableTd>
          <TableTd class="w-5/6" data-test-details-monitoring-url><Copyable>{{item.value}}</Copyable></TableTd>
        </:body>
      </Table>
    </:default>
  </Box>
</template>
